import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { DefaultPan } from 'api/traps/FeromonTraps/types';
import { DefaultPlan } from 'api/traps/Hubs/types';
import './LinkCell.scss';
import { TrapTableTypeLink } from 'components/TrapsTables/trapTables';

interface LinkCellProps {
  data: DefaultPan | null | DefaultPlan;
  icon: string;
  slug: string | undefined;
  deviceType?: TrapTableTypeLink;
  device_add_slug?: string;
}
const DeviceLinkCell: React.FC<LinkCellProps> = ({ data, icon, slug, deviceType, device_add_slug = '' }) => {
  const { t } = useTranslation();

  const link = data
    ? data.on_plan
      ? `/object/interactive-map/${slug}/${data?.url_ending.split('/')[0]}?device_zoom=${data?.url_ending.split('/')[1]}`
      : `/object/interactive-map/${slug}?device_add_slug=${device_add_slug}&device_type=${deviceType}`
    : `/object/create-plan/${slug}`;
  const is_warning = data ? !data?.on_plan : true;
  const title = data ? (data?.on_plan ? data?.title : t('TrapTables.NotOnPlan')) : t('TrapTables.NotPlanAdded');

  return (
    <Link to={link} className={`link-cell-item ${is_warning ? 'bg-warning' : ''}`}>
      <div className="icon">
        <i className={`${icon} icon rounded-pill fs-14 me-1`} />
      </div>

      <div className="text w-100 d-flex align-items-center justify-content-center">
        <span>{title || 'None'}</span>
      </div>
    </Link>
  );
};

export default DeviceLinkCell;
